import {
  Modal,
  Box,
  Grid,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DIALOG_BOX_STYLE,
  TEXT_OVERFLOW_2LINES,
} from '../../../../../../_constants/styleConst';

export type DetailItem = {
  id: string;
  label: string;
  isChecked: boolean;
  borderColor: string;
};

type InspectionDetailModalProps = {
  isOpen: boolean;
  title: string;
  details: DetailItem[];
  setDetails: Dispatch<SetStateAction<DetailItem[]>>;
  handleClose: (shouldUpdate: boolean) => void;
};

const InspectionDetailModal: React.FC<InspectionDetailModalProps> = ({
  isOpen,
  title,
  details,
  setDetails,
  handleClose,
}) => {
  const { t } = useTranslation();
  const handleCheckboxChange = (id: string) => {
    setDetails((prev) => {
      const newDetails = prev.map((detail) => {
        if (detail.id === id) {
          return { ...detail, isChecked: !detail.isChecked };
        }
        return detail;
      });
      return newDetails;
    });
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => handleClose(false)}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={[DIALOG_BOX_STYLE, { maxHeight: '90%', overflow: 'auto' }]}>
        <Box sx={{ height: '100%' }}>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ wordBreak: 'break-word' }}
          >
            {title}
          </Typography>
          <Typography id="modal-body" variant="h6" component="h3">
            <Grid container direction="column" spacing={2}>
              <Grid></Grid>
              <Grid sx={{ fontSize: '1rem' }}>
                {t('MSG_SELECT_DEFECTIVE_AREA')}
              </Grid>
              <Grid sx={{ marginLeft: '1rem' }}>
                {details.map((detail) => (
                  <Box key={`defective_area_${detail.id}`}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={detail.isChecked}
                          onChange={() => handleCheckboxChange(detail.id)}
                          sx={{
                            transform: 'scale(1.5)',
                            marginRight: '10px',
                            color: detail.borderColor,
                          }}
                        />
                      }
                      label={
                        <Typography sx={TEXT_OVERFLOW_2LINES}>
                          {detail.label}
                        </Typography>
                      }
                    />
                  </Box>
                ))}
              </Grid>
              <Grid sx={{ textAlign: 'right', width: '100%' }}>
                <Button
                  onClick={() => handleClose(false)}
                  variant="contained"
                  color="inherit"
                  sx={{ marginRight: '2%' }}
                >
                  {t('BTN_CANCEL')}
                </Button>

                <Button
                  onClick={() => handleClose(true)}
                  variant="contained"
                  disabled={details.every((detail) => !detail.isChecked)}
                >
                  {t('BTN_OK')}
                </Button>
              </Grid>
            </Grid>
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default InspectionDetailModal;
